/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import { IntegratedSearchAndNavLayout as Layout } from '../../layouts'
import UploadFormTheSequel from './components/UploadFormTheSequel'

const UploadPageStyle = {
    searchContainer: {
        flexGrow: 1,
    },
}

class UploadPage extends Component {
    constructor (props) {
        super(props)
        this.state = {}
    }

    render() {
        const { classes } = this.props

        return (
            <Layout>
                <UploadFormTheSequel />
            </Layout>
        )
    }
}

UploadPage.propTypes = {

}
UploadPage.defaultProps = {}

const mapStateToProps = state => ({ })

export default withRouter(connect(mapStateToProps)(withStyles(UploadPageStyle)(UploadPage)))
